import { makeStyles } from '@material-ui/core/styles'

const signUpStyles = makeStyles(theme => ({
  SignUpDiv: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 114px)'
  },
  SignUpBox: {
    margin: '20px',
    marginTop: '5%',
    width: '100%',
    maxWidth: '800px',
    background: '#FFF',
    boxShadow: '0px 2px 10px #3F434714'
  },
  SignUpTextBox: {
    fontWeight: 'bold',
    fontSize: '2.375em',
    padding: '0 40px',
    textAlign: 'left',
    color: '#335977'
  },
  flexSpaceBtw:
  {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px'
  },
  container: {
    textAlign: 'center',
    fontSize: '0.875em'
  },
  innerContainer: {
    padding: '10px 40px',
  },
  forgotPassword: {
    color: '#026AE3'
  },
  paper: {
    maxHeight: '200px',
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: '5px'
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#c3c3c3',
      width: '5px'
    }
  },
  headerWrapper: {
    backgroundColor: '#F7F7F7',
    padding: '0.5rem',
    color: '#F37320',
    fontWeight: 'bold',
    textAlign: 'left',
    fontSize: '18px',
    margin: '0 10px'
  },
  bottomButton: {
    marginBottom: '20px',
  },
  input: {
    '@media (min-width: 3000px)': {
      '& svg': {
        top: 'calc(50% - 25px)'
      }
    }
  }
}))

export { signUpStyles }